import React from 'react';
import PropTypes from 'prop-types';

const NavigationIcon = (
  size: string,
  { title, element }: { title: string; element: React.ReactNode },
) => (
  <svg
    focusable="false"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    aria-hidden="true"
    tabIndex={-1}
  >
    <title>{title}</title>
    {element}
  </svg>
);

const navigationPropertyTypes = {
  fillColor: PropTypes.string,
  size: PropTypes.string,
};

type NavigationProperties = PropTypes.InferProps<
  typeof navigationPropertyTypes
> & {
  fillColor?: string;
  size?: string;
};

const ArrowLeftIcon = ({
  fillColor,
  size,
}: NavigationProperties) => (
  NavigationIcon(size ?? '24', {
    title: 'ArrowLeft',
    element: (
      <path
        d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
        fill={fillColor ?? '#58595b'}
      />
    ),
  })
);

const ArrowRightIcon = ({
  fillColor,
  size,
}: NavigationProperties) => (
  NavigationIcon(size ?? '24', {
    title: 'ArrowRight',
    element: (
      <path
        d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
        fill={fillColor ?? '#58595b'}
      />
    ),
  })
);

const DotNavigationIcon = ({
  fillColor,
  size,
}: NavigationProperties) => (
  NavigationIcon(size ?? '24', {
    title: 'NavigationDot',
    element: (
      <circle
        cx="12"
        cy="12"
        r="12"
        fill={fillColor ?? '#58595b'}
      />
    ),
  })
);

ArrowLeftIcon.propTypes = navigationPropertyTypes;
ArrowRightIcon.propTypes = navigationPropertyTypes;
DotNavigationIcon.propTypes = navigationPropertyTypes;

export {
  ArrowLeftIcon,
  ArrowRightIcon,
  DotNavigationIcon,
};
